exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".fs-20{font-size:20px}.ticket-date-box{height:30px;width:30px;display:block}.ticket-date-content{position:absolute;top:0;left:30px}", "", {"version":3,"sources":["/var/www/html/wanasa/website/vue-pwa-initial-setup/src/components/pages/ConfirmVoucher.vue"],"names":[],"mappings":"AACA,OACE,cAAgB,CACjB,AACD,iBACE,YAAa,AACb,WAAY,AACZ,aAAe,CAChB,AAED,qBACE,kBAAmB,AACnB,MAAO,AACP,SAAW,CACZ","file":"ConfirmVoucher.vue","sourcesContent":["\n.fs-20 {\n  font-size: 20px;\n}\n.ticket-date-box {\n  height: 30px;\n  width: 30px;\n  display: block;\n}\n/* .ticket-date-box  */\n.ticket-date-content {\n  position: absolute;\n  top: 0;\n  left: 30px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7163ad95","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/ConfirmVoucher.vue
// module id = 1219
// module chunks = 8